import React from "react";

const TermsAndWarrantySvg = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M6.66643 22.7681H17.3336C19.413 22.7681 20.4476 21.7134 20.4476 19.6241V10.5037H13.1751C11.8894 10.5037 11.2869 9.89085 11.2869 8.60514V1.23242H6.66643C4.59729 1.23242 3.55243 2.29699 3.55243 4.38671V19.6241C3.55243 21.7233 4.59729 22.7681 6.66643 22.7681ZM13.2056 9.12756H20.337C20.2667 8.71571 19.9753 8.31371 19.5034 7.82171L13.9586 2.18685C13.4966 1.70471 13.0749 1.41328 12.6527 1.34256V8.58542C12.6527 8.94671 12.8439 9.12756 13.2056 9.12756ZM8.133 14.8533C7.72114 14.8533 7.42972 14.5618 7.42972 14.1701C7.42972 13.778 7.72114 13.487 8.13257 13.487H15.8769C16.2789 13.487 16.5904 13.7784 16.5904 14.1697C16.5904 14.5618 16.2789 14.8528 15.8773 14.8528L8.133 14.8533ZM8.133 18.68C7.72114 18.68 7.42972 18.3886 7.42972 17.9968C7.42972 17.6051 7.72114 17.3137 8.13257 17.3137H15.8769C16.2789 17.3137 16.5904 17.6051 16.5904 17.9968C16.5904 18.3886 16.2789 18.68 15.8773 18.68H8.133Z"
        fill="#006CDD"
      />
    </svg>
  );
};

export default TermsAndWarrantySvg;
